import React from 'react';

export const FormSection = ({ title, children, extra }) => (
  <div className="vo-panel-card">
    <div className="vo-panel-heading">
      {title}
      {extra}
    </div>
    <div className="vo-panel-body">
      <div className="vo-field-wrapper">{children}</div>
    </div>
  </div>
);

export const FormField = ({
  label,
  required,
  error,
  children,
  hint,
}) => (
  <div className={`vo-form-group ${error ? 'has-error' : ''}`}>
    {children}
    <label className={`vo-label ${required ? 'required' : ''}`}>{label}</label>
    {hint && <small className="vo-hint">{hint}</small>}
    {error && <span className="vo-error">{error}</span>}
  </div>
);

export const TextInput = ({ value, onChange, disabled, type = 'text', maxLength, name }) => (
  <input
    className="vo-input"
    type={type}
    name={name}
    value={value ?? ''}
    disabled={disabled}
    maxLength={maxLength}
    onChange={(e) => onChange(e.target.value)}
  />
);

export const TextAreaInput = ({
  value,
  onChange,
  disabled,
  rows = 3,
  placeholder,
  name,
}) => (
  <textarea
    className="vo-input vo-textarea"
    name={name}
    rows={rows}
    value={value ?? ''}
    disabled={disabled}
    placeholder={placeholder}
    onChange={(e) => onChange(e.target.value)}
  />
);

export const SelectInput = ({ value, onChange, disabled, options = [], placeholder = 'Please Select' }) => (
  <select
    className="vo-input"
    value={value ?? ''}
    disabled={disabled}
    onChange={(e) => onChange(e.target.value)}
  >
    <option value="">{placeholder}</option>
    {options.map((opt) => (
      <option key={opt.id} value={opt.id}>
        {opt.name}
      </option>
    ))}
  </select>
);
